import React from "react"
import AdminPanelDom from "../domains/adminPanel/adminPanelDom"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import Reports from "./Reports"

class AdminPanelReports extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({ MessaggiComponent }) => (
          <Reports
            forAdmin={true}
            activeSkinId={this.props.activeSkinId}
            MessaggiComponent={MessaggiComponent}
          />
        )}
        {...this.props}
      />
    )
  }
}
const mapStatToProps = (state) => ({
  activeSkinId: state.main.activeSkinId,
})
export default connect(mapStatToProps, MainActions)(AdminPanelReports)
